export default {
  paused: 'Les paiements en ligne sont suspendus en raison de problèmes de vérification KYC.',
  deadline_warning: 'La vérification KYC est requise, sinon les paiements en ligne seront suspendus le {{date}}.',
  complete_verification: 'Finaliser la vérification',
  partner: {
    action_needed:
      "Votre prestataire de paiement a besoin d'un dernier élément avant que ce restaurant puisse accepter les paiements en ligne.",
    hosted_incomplete:
      "Vous n'avez pas encore terminé la configuration des paiements en ligne avec votre prestataire de paiement.",
    link_expired:
      'Votre lien pour terminer la configuration des paiements en ligne a expiré. Obtenez-en un nouveau pour continuer.',
    open_error: "Le fournisseur de paiement n'a pas pu être contacté. Réessayez dans quelques minutes.",
    hosted_not_started: 'Les paiements en ligne ne sont pas encore configurés avec votre prestataire de paiement.',
    business_details_missing:
      'Ajoutez les informations de votre entreprise pour commencer à accepter les paiements en ligne.',
    continue: 'Continuer',
  },
};
